import {
  IconButton,
  ModalProps,
  Modal,
  ModalContent,
  ModalOverlay,
  Heading,
  Image,
  Container,
  Center,
  Box
} from '@chakra-ui/react'
import * as React from 'react'
import { X } from 'react-feather'
import { images } from '../../../theme'
import Card from '../../UI/Card'
import CardHeader from '../../UI/Card/CardHeader'
import { HStack } from '@chakra-ui/react'

type ModalWrapProps = ModalProps & {
  title: string
  image?: any
  rightElement?: React.ReactNode
}

const ModalWrap: React.FC<ModalWrapProps> = ({
  children,
  title,
  onClose,
  isOpen,
  image,
  rightElement,
  ...rest
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...rest}>
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(8px)" />
      <ModalContent shadow="xl" justifyContent="center" bg="transparent" borderRadius="0">
        <Card overflow="auto" bg="white" rounded="0" borderWidth={0} justifyContent="flex-start">
          <Container py={6} maxW="container.lg">
            <CardHeader
              // border="none"
              alignItems="center"
              flexDirection="row"
              justifyContent="space-between"
              p={0}
              py={4}
              borderColor="transparent"
            >
              <Heading as="h5" size="lg" fontWeight="400" letterSpacing="-0.02em">
                {title}
              </Heading>
              <IconButton
                onClick={onClose}
                aria-label="Close Modal"
                size="sm"
                icon={<X />}
                rounded="0"
                variant="ghost"
                _hover={{ bg: 'gray.100' }}
              />
            </CardHeader>
            <HStack spacing={8}>
              <Box pb={8} flex={1.4}>
                {children}
              </Box>
              {rightElement ? (
                rightElement
              ) : (
                <Center flex={1} display={{ base: 'none', md: 'flex' }}>
                  <Image
                    rounded="0"
                    draggable="false"
                    objectFit="contain"
                    src={image ? image : images.logo}
                    boxSize="45%"
                  />
                </Center>
              )}
            </HStack>
          </Container>
        </Card>
      </ModalContent>
    </Modal>
  )
}

export default ModalWrap

ModalWrap.defaultProps = {
  title: 'Modal Heading',
  size: '6xl',
  motionPreset: 'slideInBottom',
  isCentered: true,
  preserveScrollBarGap: true
}
